import { combineReducers } from 'redux'
import {nameMode,tabMode , detectHome , expandMode , setTitle , styleMode , setSocket , networkMode} from './reducers'

export default combineReducers({
    nameMode,
    detectHome,
    networkMode,
    styleMode,
    tabMode,
    expandMode,
    setTitle , 
    setSocket
})
